var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAlarm01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.002 4.548A4.82 4.82 0 0 0 7.18 9.37v5.828l-.902 1.777h11.433l-.888-1.706v-5.9a4.82 4.82 0 0 0-4.821-4.82M5.58 9.37a6.421 6.421 0 0 1 12.843 0v5.507l1.923 3.698H3.672l1.908-3.76zM13.651 21.052h-3.3v-1.6h3.3z"
}))));
export default SvgIconAlarm01;